import { FC } from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { Iconify } from '@mgm/common/components';

interface TTimeoffTableActions {
  onApprove?: (() => void) | undefined
  onReject?: (() => void) | undefined
}

const TimeoffTableActions: FC<TTimeoffTableActions> = ({
  onApprove,
  onReject,
}) => {
  const actions: JSX.Element[] = [];

  if (onApprove) {
    actions.push(
      <GridActionsCellItem
        id="edit-icon"
        key="approve"
        icon={(
          <Iconify
            width={24}
            icon="gg:check-o"
            sx={{
              color: '#10B981',
            }}
          />
)}
        label="Approve"
        onClick={onApprove}
      />,
    );
  }

  if (onReject) {
    actions.push(
      <GridActionsCellItem
        id="delete-icon"
        key="reject"
        icon={(
          <Iconify
            width={24}
            icon="material-symbols:cancel-outline"
            sx={{
              color: '#FF4842',
            }}
          />
)}
        label="Reject"
        onClick={onReject}
      />,
    );
  }

  return actions;
};

export { TimeoffTableActions };
